<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-3/4 mx-auto self-center d-theme-dark-bg">
              <validation-observer tag="div" class="p-4" #default="{valid}" ref="a2faForm">
                <div class="vx-logo flex justify-items-center items-center mb-2 pt-1">
                  <img src="@/assets/images/logo/logo.png" alt="logo" class="mx-auto" style="max-height: 25px"/>
                </div>

                <div class="vx-card__title mb-2">
                  <h4 class="mb-2 mt-4 grid justify-items-center">Validação do seu Acesso</h4>
                  <p>Por favor, acesse o aplicativo <b>Google Authenticator</b> para validar o seu Acesso.</p>
                  <p>Alternativamente, você pode utilizar a chave <b>{{a2faCode}}</b>.</p>
                </div>
                <div class="flex justify-items-center items-center grid mb-2 pt-1">
                  <b-img
                    style="max-width: 200px;"
                    :src="qrCode2fa"
                    alt="QR Code 2FA"/>
                </div>

                <validation-provider name="Código" rules="required" #default="{errors}">
                  <vs-input
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    label-placeholder="Código"
                    v-model="code2fa"
                    class="w-full"/>
                  <label class="text-danger">{{ errors[0] }}</label>
                </validation-provider>

                <div class="flex flex-row gap-2 flex-wrap justify-center mt-1">
                  <div>
                    <vs-button :disabled="!valid" @click="verify2fa">Validar Acesso</vs-button>
                  </div>
                  <div>
                    <vs-button type="border" to="/login">Voltar para Login</vs-button>
                  </div>
                </div>

              </validation-observer>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

import TwoFactorService from '@/services/api/TwoFactorService'


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BLink,
    BImg,
  },
  data() {
    return {
      code2fa: '',
      a2faCode: '',
      qrCode2faImg: '',
      services: {
        twoFactorService: null
      },
    }
  },
  computed: {
    qrCode2fa(){
      return this.qrCode2faImg
    }
  },
  methods: {
     getQr2fa() {
      this.$vs.loading()

      const userInfo = this.getUserInfoAut()

      this.services.twoFactorService.getQRCodeURL(userInfo).then(
        data => {
          this.qrCode2faImg = data.qr_code_img
          this.a2faCode = data.a2fa_code
        },
        error => {
          this.notifyError(this.$vs, "Não foi possível gerar QRCode de validação. Realize o login novamente!", 5000)
          localStorage.removeItem('userInfoAut')
          this.$router.push('/login')
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    verify2fa(){
      const userInfo = this.getUserInfoAut()

      const params = {
        email: userInfo.email,
        password: userInfo.password,
        one_time_password: this.code2fa
      }

      this.services.twoFactorService.verify2fa(params).then(
        data => {
          this.notifySuccess(this.$vs)

          const userInfoStr = localStorage.getItem('userInfoAut')
          const userInfoObject = JSON.parse(userInfoStr)
          userInfoObject.user = data;

          //
          const payload = {
            updateUsername: userInfoObject.updateUsername,
            user: userInfoObject.user,
            updateUsername: true,
            vs: this.$vs,
            closeAnimation: this.$vs.loading.close,
            acl: this.$acl
          }

          this.$store.dispatch('auth/loginSuccess', payload)

          localStorage.removeItem('userInfoAut')
        },
        error => {
          this.notifyErrors(this.$vs, error, 5000)
        }
      ).finally(() => {this.$vs.loading.close()})
    },
    getUserInfoAut(){
      const userInfoStr = localStorage.getItem('userInfoAut')
      const userInfoObject = userInfoStr ? JSON.parse(userInfoStr) : null

      let userInfo = {email: '', password : ''}

      if(userInfoObject){
        userInfo.email = userInfoObject.userDetails.email
        userInfo.password = userInfoObject.userDetails.password
      }else{
        this.notifyError(this.$vs, "Não foi possível iniciar a validação de 2FA. Realize o login novamente!", 5000)
        localStorage.removeItem('userInfoAut')
        this.$router.push('/login')
        return
      }

      return userInfo

    }
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.twoFactorService = TwoFactorService.build(this.$vs)

    promisses.push(
      this.getQr2fa()
    )
  },
  mounted() {


  }
}
</script>
